<template>
    <div class="subject">
        <div class="new-ad" id="ad" v-if="id == 29">
            <img src="../../assets/images/ad.jpg" alt="">
        </div>
        <HeaderImage :image="headerImage"></HeaderImage>
        <Carousel :data="carousel"></Carousel>
        <News :data="list" :cateId="cateId" :topic="topic" @getNewList="getNewList"></News>
    </div>
</template>

<script>
import Carousel from "./carousel";
import HeaderImage from "./headerimage";
import News from "./news";
import $ from "jquery";

export default {
    name: "Subject",
    components: {
        HeaderImage,
        Carousel,
        News
    },
    data () {
        return {
            id: this.$route.params.id,
            headerImage: "",
            carousel: [],
            list: [],
            cateId: null,
            topic: '点击加载更多',
            bLen: 0
        }
    },
    methods: {
        getData(){
            this.axios.get("/webtopic/getWebTopic/" + this.id).then(res => {
                let data = res.data.data;
                this.cateId = res.data.data.cateId;
                document.title = data.title;
                document.shareImage = data.topImgurl;
                this.bLen = data.bottomlist.length;

                this.headerImage = data.topImgurl
                if(this.headerImage) {
					this.$bus.$emit("setTitle", {
						title: data.title,
						description: data.description ? data.description : data.title,
						shareImage: this.headerImage
					})
				}
                if(data.runlist.length){
                    this.carousel = data.runlist.map(item => {
                        return {
                            title: item.title,
                            url: item.shareUrl,
                            image: item.images['0'] || "",
                        }
                    })
                }
                this.axios.get("/webtopic/list", {
                    params:{
                        cateId: this.cateId,
                        page: 1,
                        limit: 10
                    }
                }).then((res) => {
                    this.list = res.data.data
                })
            })
        },  
        getNewList(page){
            let nLen = this.list.length;
            if(nLen >= this.bLen){
                this.topic = '已经没有更多了';
                return
            }
            this.topic = '正在加载...';
            setTimeout(() => {
                this.axios.get("/webtopic/list", {
                    params:{
                        cateId: this.cateId,
                        page,
                        limit: 10
                    }
                }).then((res) => {
                    this.topic = '点击加载更多';
                    this.list = this.list.concat(res.data.data);
                })
            }, 500)
        },
        getStatistPv(){
            this.axios.get('http://dcy.gxnews.com.cn/insert.php', {
                params: {
                    tag: 'zgapp-zt',
                    t: Math.random()
                }    
            })   
        }
    },
    mounted () {
        this.getData();
        this.getStatistPv();
        window.addEventListener('hashchange', () => {
            // 解决专题里面链专题点击不刷新的问题
            if(this.id!=this.$route.params.id) 
                window.location.reload();
        }, false)
        if(this.id == 29){
            setTimeout(() => {
                $('#ad').fadeOut(1000);
            }, 3000)
        }
    }
}
</script>

<style lang="less" scoped>
    .new-ad{
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 1000;
        img{
            width: 100%;
        }
    }
</style>
